export function lengthDirX(angle: number, length: number, rads: boolean = false): number {
  if (rads) {
    return Math.cos(angle) * length;
  } else {
    return Math.cos(Phaser.Math.degToRad(angle)) * length;
  }
}

export function lengthDirY(angle: number, length: number, rads: boolean = false): number {
  if (rads) {
    return Math.sin(angle) * length;
  } else {
    return Math.sin(Phaser.Math.degToRad(angle)) * length;
  }
}
